import React from "react";
import { faBolt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Feature({ featureTitle, featureText }) {

  return (
    <div className="flex mt-6 md:mt-0">
      <div className="flex-shrink-0">
        <FontAwesomeIcon className="text-indigo-600" icon={faBolt} size="2x" />
      </div>
      <div className="ml-4">
        <h4 className="text-xl leading-6 font-bold text-gray-900">{featureTitle}</h4>
      </div>
    </div>
  )
}

export default Feature;
